import ProductMenu from "../components/ContentUnit/Menus/ProductMenu";
import ActiveProduct from "../components/ContentUnit/Products/activeProduct/ActiveProduct";
import ChangeProductStatus from "../components/ContentUnit/Products/changProductStatus/ChangeProductStatus";
import FinishedProduct from "../components/ContentUnit/Products/finishedProduct/FinishedProduct";
import MyProduct from "../components/ContentUnit/Products/myProduct/MyProduct";
import NewProduct from "../components/ContentUnit/Products/newProducts/NewProduct";
import SubmitPorduct from "../components/ContentUnit/Products/SubmitProduct/SubmitPorduct";
import OnlineChatSupplier from "../components/OnlineChatSupplier/OnlineChatSupplier";
import SupAccountant from "../components/SupAccountant/SupAccountant";
import SupplierAwaitingDelivery from "../components/SupplierAwaitingDelivery/SupplierAwaitingDelivery";
import SupplierContentUnit from "../components/SupplierContentUnit/SupplierContentUnit";
import { SupplierDashboard } from "../components/SupplierDashboard/SupplierDashboard";
import SupplierUnconfirmedOrders from "../components/SupplierUnconfirmedOrders/SupplierUnconfirmedOrders";
import StagnantProduct from "../components/ContentUnit/Products/stagnantProducts/StagnantProduct";
import ProductCategoryMenu from "../components/ContentUnit/Menus/ProductCategoryMenu";
import LevelFirst from "../components/ContentUnit/ProductProperty/level1/LevelFirst";
import LevelSecond from "../components/ContentUnit/ProductProperty/level2/LevelSecond";
import AddBrand from "../components/ContentUnit/ProductCategory/AddBrand/AddBrand";
import TextTemplate from "../components/ContentUnit/ProductCategory/TextTemplate/TextTemplate";
import LevelThid from "../components/ContentUnit/ProductCategory/LevelThird/LevelThid";
import SupplierFeatures from "../components/SupplierFeatures/SupplierFeatures";
import { lazy } from "react";
import TicketsList from "../components/TicketsList/TicketsList";
const LevelFirstProdcutRoute = lazy(() =>
  import("../components/ContentUnit/ProductCategory/LevelFirst/LevelFirst")
);
const LevelSecondProductRoute = lazy(() =>
  import("../components/ContentUnit/ProductCategory/LevelSecond/LeveleSecond")
);
const LevelThirdProductRoute = lazy(() =>
  import("../components/ContentUnit/ProductCategory/LevelThird/LevelThid")
);
export const SupplierRoute = [
  {
    path: "/",
    className: "dashboard",
    component: <SupplierDashboard />,
  },
  {
    path: "/accounting",
    className: "accounting",
    component: <SupAccountant />,
  },
  {
    path: "/accounting/unconfirmedOrders",
    className: "unconfirmedOrders",
    component: <SupplierUnconfirmedOrders />,
  },
  {
    path: "/accounting/awaitingDelivery",
    className: "awaitingDelivery",
    component: <SupplierAwaitingDelivery />,
  },
  {
    path: "/OnlineChat",
    className: "online-chat",
    component: <OnlineChatSupplier />,
  },
  {
    path: "/ContentUnit",
    className: "content-unit",
    component: <SupplierContentUnit />,
  },
  {
    path: "/ContentUnit/products",
    className: "product",
    component: <ProductMenu supplier />,
  },
  {
    path: "/ContentUnit/products/activeProduct",
    className: "active-product",
    component: <ActiveProduct />,
  },
  {
    path: "/ContentUnit/products/changeProductStatus",
    className: "change-product-status",
    component: <ChangeProductStatus />,
  },
  {
    path: "/ContentUnit/products/finishedProduct",
    className: "finished-product",
    component: <FinishedProduct />,
  },
  {
    path: "/ContentUnit/products/myProduct",
    className: "supplier",
    component: <MyProduct />,
  },
  {
    path: "/ContentUnit/products/submitedProduct",
    className: "supplier",
    component: <SubmitPorduct />,
  },
  {
    path: "/ContentUnit/products/addNewProduct",
    className: "add-product",
    component: <NewProduct />,
  },
  {
    path: "/ContentUnit/products/rockedProduct",
    className: "stagnant-product",
    component: <StagnantProduct />,
  },
  {
    path: "/ContentUnit/productCategory",
    className: "product-category",
    component: <ProductCategoryMenu supplier />,
  },
  {
    path: "/ContentUnit/productCategory/level1-product-category",
    className: "product-category",
    component: <LevelFirstProdcutRoute />,
  },
  {
    path: "/ContentUnit/productCategory/level2-product-category",
    className: "product-category",
    component: <LevelSecondProductRoute />,
  },
  {
    path: "/ContentUnit/productCategory/level3-product-category",
    className: "product-category",
    component: <LevelThirdProductRoute />,
  },
  {
    path: "/ContentUnit/productCategory/addBrand",
    className: "product-category",
    component: <AddBrand />,
  },
  {
    path: "/ContentUnit/productCategory/addTextTemplateTable",
    className: "add-text-template-table",
    component: <TextTemplate />,
  },
  {
    path: "/ContentUnit/features",
    className: "features",
    component: <SupplierFeatures />,
  },
  {
    path: "/ContentUnit/features/level-one",
    className: "features-level-one",
    component: <LevelFirst />,
  },
  {
    path: "/ContentUnit/features/level-two",
    className: "features-level-two",
    component: <LevelSecond />,
  },
];
